(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-image"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

    const swiperBrand = new Swiper('.brandSwiper', {

      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 50,
     mousewheel: {
          forceToAxis: true
        },
      grabCursor: true,
      spaceBetween: 12,
       breakpoints: {
        // when window width is >= 320px
        320: {
    
           spaceBetween: 10,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 5,
        }
      }
});
  

});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finder"] && !Shopify.designMode) return;
  try {
    

  $(document).ready(function () {
        String.prototype.count = function (s1) {
            return (this.length - this.replace(new RegExp(s1, "g"), '').length) / s1.length;
        }

    function initMap() {

      let lat = 52.5050119;
      let lng = 12.7653902;
      let zoom = 10; 

      let points = [
  [52.230020586193795, 21.01083755493164, "point 1"],
  [52.22924516170657, 21.011320352554325, "point 2"],
  [52.229511304688444, 21.01270973682404, "point 3"],
  [52.23040500771883, 21.012146472930908, "point 4"],
];
      
      const map = L.map('map').setView([ lat, lng ], zoom);

      const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: zoom,
      }).addTo(map);


      for (let i = 0; i < points.length; i++) {
        const [lat, lng, popupText] = points[i];
      
        marker = new L.marker([lat, lng]).bindPopup(popupText).addTo(map);
      }

 
    }
    
    initMap();

  });
               

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		this.elements.input.value = event.currentTarget.dataset.value;
		this.querySelector('form')?.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
	}

	closeSelector(event) {
		const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  $('.rotation-text li').first().addClass('active');
 setInterval(function(){
    let nextEl =  $('.rotation-text li.active').next();
  
   if(nextEl.length == 0){
      nextEl =  $('.rotation-text li').first();
   }
    $('.rotation-text li').removeClass('active');
   
   nextEl.addClass('active');
 }, 2000);
  
class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              requestAnimationFrame(this.showSticky.bind(this));
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
          
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
         
			if (!this.preventReveal) {
            
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
       
           requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

    showSticky(){
      this.header.classList.add('show-sticky');
    }

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'show-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'show-sticky');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
	}
}

customElements.define('sticky-header', StickyHeader);

  
const searchDetails = document.querySelector('.header__search details');
document.addEventListener('keyup', (e) => {
	if (e.key === 'Escape' && searchDetails) {
		searchDetails.removeAttribute('open');
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  
$(document).ready(function () {

    $('.cat-filter').on('click', function(){
        $(this).toggleClass('active');
    })
})
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

 
  
$(document).ready(function () {

    function advancedPaymentPrice(){
      let priceZero = $('.main-price').attr('data-price');
      let price = priceZero / 100;
      let currencySymbol = $('.main-price').attr('data-currency');
      let quantity = $('.quantity__input').val();

      let result = quantity * (price - (price *  0.03));
      let localSum = parseFloat(result.toFixed(2)).toLocaleString();
      $('#advance_payment_value').html(localSum + ' ' + currencySymbol)
     
    }

  advancedPaymentPrice()

       $('#show-sample').on('click', function(e){
         e.preventDefault();
         
          if(!$('.sidebar_wrapper').hasClass('active')){
            $('.sidebar_wrapper').addClass('active')
            $('body').addClass('hasSidebar')
          }else{
           closeSidebar()
          }
        })
  
      /*close*/
      $('.close_sample_product,.add_to_cart_sample,.sidebar_wrapper_close').on('click', function(){
        closeSidebar()
      })

    function closeSidebar(){
       $('.sidebar_wrapper').removeClass('active')
         $('body').removeClass('hasSidebar')
    }

    $('.product-parameters.var_size').on('click', function(e) {
      
	   window.dispatchEvent(new CustomEvent('sidebar-open'));
       console.log('sidebar opened event')
    })
  
    $('.var_size .product-form__input,.var_size label').on('click', function(e){
    
   /*  $('.var_size label').on('click', function(e){ */
     
        let sidebar = $('#product_size');
          if(!sidebar.hasClass('active')){
            sidebar.addClass('active')
            $('body').addClass('hasSidebar')
          }else{
           closeSidebar()
          }
    })


  $('.size_item_sidebar').on('click',function(){
      $('.size_item_sidebar.selected').removeClass('selected');
      $(this).addClass('selected');
       
  })
    $('.size_title').on('click',function(){
      
      closeSidebar()
    })

  

  if($('.product__description').length > 0){

 $(".desc_read_more").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = '#full_desc';

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 100
      }, 800);
    } // End if
  });

  }

  
$('.product__media-list').slick(getSliderSettings());

let subslider = $('.product__media-sublist').slick(getSubSliderProductSettings());
                        
  subslider.on('wheel', (function(e) {
        e.preventDefault();
    
        clearTimeout(scroll);
        scroll = setTimeout(function(){scrollCount=0;}, 200);
        if(scrollCount) return 0;
        scrollCount=1;
    
        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    }));                                                
});




  } catch(e) { console.error(e); }
})();
})();
